export const processSteps = [
  {
    step: "01",
    title: "选择投稿通道",
    desc: "在线表单、邮箱私信或议题线索征集，任选其一即可，不需要注册账号。",
  },
  {
    step: "02",
    title: "写下你掌握的信息",
    desc: "尽量交代清楚时间、地点、涉及方与具体经过，手上有材料可以一并说明。",
  },
  {
    step: "03",
    title: "编辑核实与交叉比对",
    desc: "编辑部在 1 至 3 个工作日内初筛，必要时通过你留下的方式补充求证。",
  },
  {
    step: "04",
    title: "隐去身份后发布",
    desc: "核实通过的内容会去除所有可识别信息，再以「知情者说」形式对外呈现。",
  },
];